<template>
	<footer class="footer">
		<div class="container">
			<div class="footer-content">
				<div class="footer-links">
					<div class="footer-column">
						<h3>主办单位</h3>
						<ul>
							<li><a href="#" @click="handleLink('http://jtia.jiangtai.com')">江泰国际合作联盟</a></li>
							<li><a href="#" @click="handleLink('http://www.dajiuxing.com.cn/jiuyuanlm/#/home')">江泰全球救援联盟</a></li>
						</ul>
					</div>
					<div class="footer-column">
						<h3>支持单位</h3>
						<ul>
							<li><a href="#" @click="handleLink('http://www.ciodpa.org.cn/')">中国产业海外发展协会</a></li>
						</ul>
					</div>
					<div class="footer-column">
						<h3>联系方式</h3>
						<ul>
							<li><a href="#">电话：+86 10 6980 8888</a></li>
							<li><a href="#">邮箱：ceggrc@jiangtai.com</a></li>
						</ul>
					</div>
					<div class="footer-column">
						<h3>关注我们</h3>
						<ul>
							<div class="social-links">
								<a href="#" class="social-link">
									<img src="@/assets/images/djx.jpg" alt="大救星" class="social-icon">
								</a>
								<a href="#" class="social-link">
									<img src="@/assets/images/youtou.jpg" alt="优投" class="social-icon">
								</a>
							</div>
						</ul>
					</div>
				</div>
			</div>
			<div class="footer-bottom">
				<div class="copyright">
					<p>© 中国企业走出去风险发布会</p>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    handleLink(url) {
      window.open(url, '_blank');
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #222;
  color: #fff;
  padding: 60px 0 30px;
  margin-top: auto;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 40px;
}

.footer-logo {
  flex: 0 0 100%;
  margin-bottom: 30px;
}

.footer-logo img {
  height: 40px;
}

.footer-links {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.footer-column {
  flex: 1;
  min-width: 200px;
}

.footer-column h3 {
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: #fff;
}

.footer-column ul {
  list-style: none;
}

.footer-column ul li {
  margin-bottom: 10px;
}

.footer-column ul li a {
  color: #aaa;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-column ul li a:hover {
  color: #fff;
}

.footer-bottom {
  border-top: 1px solid #444;
  padding-top: 30px;
  /* display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center; */
}

.social-links {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 15px;
}

.social-link {
  display: block;
  width: 240px;
  height: 80px;
  overflow: hidden;
  border-radius: 4px;
  transition: transform 0.3s ease;
}

.social-link:hover {
  transform: translateY(-2px);
}

.social-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.copyright {
  color: #aaa;
  font-size: 0.9rem;
  text-align: center;
}

.copyright p {
  margin-bottom: 5px;
}

@media (max-width: 992px) {
  .footer-column {
    flex: 0 0 calc(50% - 15px);
    margin-bottom: 30px;
  }
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
  }
  
  .footer-column {
    flex: 0 0 100%;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 20px;
  }
  
  .copyright {
    text-align: center;
  }
  
  .social-links {
    gap: 15px;
  }
  
  .social-link {
    width: 200px;
    height: 70px;
  }
}

@media (max-width: 480px) {
  .social-links {
    gap: 10px;
  }
  
  .social-link {
    width: 160px;
    height: 60px;
  }
}
</style> 